var _defs, _polygon, _rect, _polygon2, _polygon3, _path, _rect2, _path2, _rect3, _polyline, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAviatrickslogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 394.12 97.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5e2e91;}.cls-2{fill:#231f20;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "aviatricks_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75.94 52.99 83.65 52.99 94.34 76.29 105.55 52.99 112.91 52.99 94.42 97.14 75.94 52.99"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.56,
    y: 52.99,
    width: 8.23,
    height: 42.74
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "132.18 95.74 149.87 52.99 168.44 95.74 161.43 95.74 150.31 72.44 139.88 95.74 132.18 95.74"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "162.48 59.83 162.48 52.99 193.84 52.99 193.84 59.83 182.45 59.83 182.63 95.74 173.52 95.74 173.87 60 162.48 59.83"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267,128.15s14.36-15.51-7.71-29.35h-21.9v42.75h10v-7.71s13.14-2.28,12.79,7.71h11s1.25-10.62-13.27-15.09c0,0-12.74-2.56-12.68-13.93a19.49,19.49,0,0,0-1.67-6.51.61.61,0,0,1,.56-.87c4.28,0,20.88,1,16.75,16.65a10,10,0,0,1-5.65-6.44,11.23,11.23,0,0,0-4.05-5.27.39.39,0,0,0-.56.52,28,28,0,0,1,2.58,6.15,12.66,12.66,0,0,0,2.36,4.81,6.6,6.6,0,0,0,3.35,2.33S267.18,127.27,267,128.15Z",
    transform: "translate(-34.95 -45.81)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 243.24,
    y: 52.99,
    width: 8.15,
    height: 42.74
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M324.53,111.68",
    transform: "translate(-34.95 -45.81)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 306.39,
    y: 53.26,
    width: 8.8,
    height: 41.65
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.2 77.08 330.39 95.47 341.34 95.47 323.74 74.08 340.56 53.26 331.36 53.26 315.2 72.57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401.69,110.28h8.85s1.23-12.44-15.15-12.62c0,0-14.4-.23-14.7,12.9a10,10,0,0,0,.87,4.46,12.59,12.59,0,0,0,10.67,7.52s5.69.69,8.69,3.56a5,5,0,0,1-2.46,8.43,10.13,10.13,0,0,1-1.34.22,6.82,6.82,0,0,1-5.79-2.15,5.18,5.18,0,0,1-1.29-4l-9.36.09s-.41,11.21,12,13c1.2.17,2.42,0,3.63.05,3.75.17,12.93-2,15.18-10.39,0,0,3.12-10.78-13.84-15.07,0,0-8.24-1.3-7.8-6.41a4.85,4.85,0,0,1,3.17-4C395.49,104.88,399.45,104.47,401.69,110.28Z",
    transform: "translate(-34.95 -45.81)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M398.92,79.23l28.45-.9s3.82,2.16,0,4.86l-28-1s-2.36,1.38.34,3.94l7.29,0s10.48,5.75,6.77,9a5.92,5.92,0,0,1-5.56,0l-2.91-2.38-19.05-.07L384,94.6a5.94,5.94,0,0,1-5.56,0c-3.72-3.29,6.74-9.07,6.74-9.07h7.29c2.7-2.56.33-3.94.33-3.94l-28,1.12c-3.81-2.7,0-4.86,0-4.86l28.38,1.44,2.41-3.73a.59.59,0,0,1,1,0Z",
    transform: "translate(-34.95 -45.81)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M324.53,112.14h9.85s-3.15-10.41-14.22-13.23a21.41,21.41,0,0,0-27.09,18.45,21.56,21.56,0,0,0,5.21,17l.23.25a23.25,23.25,0,0,0,20.88,7.08c5.89-1,12.42-4.4,15-14h-9.85s-3.42,8.56-13.67,6.06c0,0-11.51-2.42-8.67-17.38a12.7,12.7,0,0,1,5-8.13,11.31,11.31,0,0,1,6.24-2.08S321.9,106,324.53,112.14Z",
    transform: "translate(-34.95 -45.81)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.11,90a70.76,70.76,0,0,1-3.61,14,61.14,61.14,0,0,1-8,15.28c-7.65,10.39-20.13,18.76-40.29,15.3l-3.11,7.6H46.56a45.49,45.49,0,0,1,13-23,40.17,40.17,0,0,1,21.21-10.06s-8.06-3-19.16,5a58,58,0,0,0-12.9,13.51s1.57-17.21,17.49-24.7A36.3,36.3,0,0,1,78,99.85a46.85,46.85,0,0,0,7-1.07,58.58,58.58,0,0,0,12.48-4.26A51.32,51.32,0,0,0,105.11,90Z",
    transform: "translate(-34.95 -45.81)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.44,95.12,96,91.19,76.82,45.81,35,143h7.27S41.52,107.21,68,98.8l8.5-21.11Z",
    transform: "translate(-34.95 -45.81)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.4,109.58a25.76,25.76,0,0,1-7.37,13L104.32,143h13.27Z",
    transform: "translate(-34.95 -45.81)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviatrickslogo);
export default __webpack_public_path__ + "static/media/aviatrickslogo.17db34788f2441c3fcc501e7b5aafcdc.svg";
export { ForwardRef as ReactComponent };